import { FunctionComponent, TextareaHTMLAttributes, useId } from "react";
import cx from "clsx";
import { Label } from "../../atoms/Label";
import { InlineErrorMessage } from "../../atoms/Errors/InlineErrorMessage";

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  labelText: string;
  description?: string;
  inlineerrormessage?: string;
  maxLength?: number;
  for?: string;
  subtext?: string;
}

export const TextArea: FunctionComponent<TextAreaProps> = ({
  className,
  labelText,
  description,
  ...props
}) => {
  const id = useId();
  const maxLength = props.maxLength ?? 500;
  return (
    <div className="body-1 my-4">
      <Label
        text={labelText}
        className="header-1 my-3"
        htmlFor={props.id ?? id}
      />
      <div className={cx("max-w-lg", className)}>
        {props?.subtext !== null && (
          <pre className="body-1 max-w-lg whitespace-pre-wrap">
            {props.subtext}
          </pre>
        )}
        <div className="mb-3 font-light">{description}</div>
        <InlineErrorMessage message={props.inlineerrormessage} />
        <textarea
          id={props.id ?? id}
          className="textarea block w-full resize-none rounded border border-[#AFB6C9] bg-[#F3F6FA] p-2"
          {...props}
          maxLength={maxLength}
        />
      </div>
    </div>
  );
};
